import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFoursquareComponent } from './simple-icons-foursquare.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFoursquareComponent ],
    exports:      [ SimpleIconsFoursquareComponent ],
    bootstrap:    []
})
export class SimpleIconsFoursquareModule {}
